<app-sidebar-items [menuItems]="menuItems" [setBackground]="false"></app-sidebar-items>
